export enum ContactAttributes {
  INTENTS = 'intents',
  TRANSCRIPT = 'transcript',
  PHONE_NUMBER = 'phonenumber',
  OUTBOUND_CAMPAIGN = 'cwneonoutboundcampaign',
  OUTBOUND_CAMPAIGN_DESCRIPTION = 'cwneonoutboundcampaigndescription',
}

//-- Attached Data --//

// When nothing is set, this means we want to display this in both incoming and active
export const DYNAMIC_CW_NEON = /^CW-NEON(.[^_]*)?_/;

export const DYNAMIC_CW_NEON_ACTIVE = /^CW-NEON-ACTIVE(.[^_]*)?_/;
export const DYNAMIC_CW_NEON_INCOMING = /^CW-NEON-INC(.[^_]*)?_/;

//-- Custom tasks --//

export const OUTBOUND_CAMPAIGN = 'CW-NEON-OUTBOUND-CAMPAIGN';
export const OUTBOUND_CAMPAIGN_DESCRIPTION = 'CW-NEON-OUTBOUND-CAMPAIGN-DESCRIPTION';
export const OUTBOUND_CAMPAIGN_QUEUE_ARN = 'CW-NEON-OUTBOUND-CAMPAIGN-QUEUE-ARN';

//-- UI restrictions --//

export const AVAILABLE_TRANSFER_QUEUE_ARNS = 'NEONNOW_AVAILABLE_TRANSFER_QUEUE_ARNS';
export const AVAILABLE_FROM_EMAILS = 'NEONNOW_AVAILABLE_FROM_EMAILS';
export const CONTACT_HIDE_TRANSFER_ACTIONS = 'NEONNOW_CONTACT_HIDE_TRANSFER';
export const CONTACT_END_TASK_WARNING = 'NEONNOW_CONTACT_END_TASK_WARNING';

//-- Feature toggles --//

export const CALL_RECORDING = 'NEONNOW_CALL_RECORDING';

//-- Contact actions --//
export const CONTACT_AUTO_ANSWER = 'NEONNOW_CONTACT_AUTO_ANSWER';
export const CONTACT_SKIP_ACW = 'NEONNOW_CONTACT_SKIP_ACW';
export const CONTACT_TASK_PAUSING = 'NEONNOW_CONTACT_TASK_PAUSING';

//-- Other --//
export const DEFAULT_FROM_EMAIL = 'NEONNOW_DEFAULT_FROM_EMAIL';
